<template>
  <div style="height:100%">
    <div class="addNewClass">
      <div class="content">
        <div class="operation">
          <el-row :gutter="20" style="width:100%">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-button
                  type="primary"
                  :round="false"
                  size="small"
                  icon="el-icon-plus"
                  @click="addPop"
                >
                  <span>添加标签项</span>
                </el-button>
              </div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="grid-content bg-purple seach">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link" style="margin-right:10px">
                    所有
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>黄金糕</el-dropdown-item>
                    <el-dropdown-item>狮子头</el-dropdown-item>
                    <el-dropdown-item>螺蛳粉</el-dropdown-item>
                    <el-dropdown-item>双皮奶</el-dropdown-item>
                    <el-dropdown-item>蚵仔煎</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input placeholder="请输入内容" v-model="screenInput" clearable size="small"></el-input>
                <el-button type="primary" size="small">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="tableoperation"></div> -->
        <template>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column>
              <template slot="header">
                <div class="lft">
                  <el-button size="mini">批量删除</el-button>
                  <!--  @click="deletes" -->
                </div>
                <div style="float:right">
                  <span>共{{ tableData.length }}条记录</span>
                </div>
              </template>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="标签名称" min-width="200">
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column label="属性" min-width="200">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(item, index) in scope.row.valueArr"
                    :key="index"
                    style="margin-left:10px"
                  >{{item}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip width="120">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                    icon="el-icon-edit"
                  ></el-button>
                  <el-button
                    size="mini"
                    @click="handledelet(scope.$index, scope.row)"
                    icon="el-icon-delete"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
    <!--添加弹窗-->
    <el-dialog title="添加标签项" width="50%" :visible.sync="showScreen">
      <el-form ref="formdata" :model="form" label-width="80px">
        <el-form-item prop="name" label="标签名称" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.group_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标签属性" :label-width="formLabelWidth">
          <el-tag
            :key="idx"
            closable
            v-for="(tag, idx) in form.param"
            style="margin-left: 10px"
            :disable-transitions="false"
            @close="handleClose(tag, idx)"
          >{{tag}}</el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="tagval"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button
            class="button-new-tag"
            style="margin-left:6px"
            v-else
            ctype="info"
            icon="el-icon-plus"
            circle
            @click="showInput"
          ></el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showScreen = false">取 消</el-button>
        <el-button v-if="dialog_status" type="primary" @click="showScreen = false">确 定</el-button>
        <!--  makeData() -->
        <!-- <el-button v-else type="primary" @click="submitEditCon()">修 改</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import addLabelgroup from "@/components/commodity/addLabelgroup.vue";
import editLabelgroup from "@/components/commodity/editLabelgroup.vue";
import {
  labelList,
  addlabel,
  delLabel,
  editLabel,
  labelListDeatil
} from "@/api/mall";
export default {
  components: {
    addLabelgroup,
    editLabelgroup
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      idx: 1,
      screenInput: "",
      nowIDx: 0,
      nowdata: {},
      tableData: [
        {
          id: 40,
          name: "ffffff",
          value: "ff,ff,ffffff",
          sort: null,
          is_show: null,
          app_id: 296,
          store_id: 0,
          merch_id: 100,
          create_time: "2020-02-05 11:57:19",
        }
      ],
      multipleSelection: [],
      inputVisible: false,
      showScreen: false, // 添加/修改
      dialog_status: true, // 弹窗
      row_obj: {}, // 详情信息
      formLabelWidth: "80px",
      tagval: "",
      form: {
        group_name: "",
        param: []
      },
    };
  },
  methods: {
    addPop(){
      this.showScreen = true,
      this.dialog_status = true,
      this.form.group_name='',
      this.form.param=[]
    },
    // 删除标签
    handleClose(tag, idx) {
      try {
        this.form.param.splice(this.form.param.indexOf(tag), 1);
        console.log(this.form.param);
      } catch (error) {
        console.log(error);
      }
    },
    // 添加属性
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.tagval;
      if (inputValue) {
        this.form.param.push(inputValue);
      }
      this.inputVisible = false;
      this.tagval = '';
    },
    // 添加分
    makeData() {
      try {
        this.$refs.formdata.validate((valid) => {
          if (valid && this.form.param.length) {
            this.form.token = this.token;
            this.form.app_id = this.app_id;
            let obj = {
              token: this.token,
              app_id: this.app_id,
              merch_id: this.merch_id,
              name: this.form.group_name,
              value: this.form.param.join(",")
            }
            // return obj;
            const res = addlabel(obj).then(res => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.form = {
                  group_name: "",
                  param: []
                };
                this.getlist();
              } else {
                this.$message.warning(res.msg);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } catch (error) {
        this.$message(error);
      }
    },
    deletes() {
      // 多选删除
      if (this.multipleSelection.length == 0) {
          this.$message({
            message: "请选择后操作",
            type: "warning"
          });
        } else {
          let data = {};
          let arrid = [];
          for (const item in this.multipleSelection) {
            if (this.multipleSelection.hasOwnProperty(item)) {
              const element = this.multipleSelection[item].id;
              arrid.push(element);
            }
          }
          data = { token: this.token, id: arrid.join(','), app_id: this.app_id };
          delLabel(data).then(res => {
            this.$message(res.msg);
            this.$nextTick(() => {
              this.getlist();
            });
          });
        }
      },

    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    // 编辑
    handleEdit(index, row) {
      this.nowdata = row;
      this.showScreen = true;
      this.dialog_status = false;
      this.form.group_name = row.name;
      this.form.param = [];
      this.getRowDetail(row.id);
      try {
        if (row.valueArr.length > 0) {
          for (let i in row.valueArr) {
            this.form.param.push(row.valueArr[i]);
          }
        } else {
          throw("暂无属性")
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取详情信息
    getRowDetail(id) {
      this.row_obj = {};
      this.row_obj = this.tableData[id];
      // let data = { token: this.token, app_id: this.app_id, id: id }
      // labelListDeatil(data).then(res =>{
      //   if (res.code == 1) {
      //     this.row_obj = {};
      //     this.row_obj = res.data;
      //   }
      // })
    },
    // 提交修改内容
    submitEditCon() {
      var obj = {
        token: this.token,
        app_id: this.app_id,
        id: this.nowdata.id,
        name: this.form.group_name,
        value: this.form.param.join(",")
      }
      const res = editLabel(obj).then(res => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.showScreen = false;
          this.form =  {
            group_name: "",
            param: []
          };
          this.getlist();
        } else {
          this.$message.warning(res.msg);
        }
      })
      
    },
    // 删除
    handledelet(index, row) {
      this.$confirm('确认删除该标签分？')
        .then(_ =>{
          let data = {
            token: this.token,
            id: row.id,
            app_id: this.app_id
          };
          delLabel(data).then(res => {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getlist();
          });
        })
        .catch(_ => {})
    },
    // 获取列表
    getlist() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id
      };
      labelList(data).then(res => {
        console.log(res);
        let data = res.data;
        this.tableData = data;
        for(var i = 0; i < data.length; i++){
          this.tableData[i].valueArr = data[i].value.split(",");
        }
      });
    }
  },
  mounted() {
    // this.getlist();
  }
};
</script>

<style lang="scss" scoped>
el-table {
  height: calc(100% - 20px);
}
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    width: 96%;
    height: 80%;
    overflow-y: scroll;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .tableoperation {
      height: 40px;
      margin-top: 20px;
      line-height: 40px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 0;
    }
    .seach {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .el-input {
        width: 200px;
      }
    }
    .el-table {
      margin-top: 20px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      .stats {
        width: 50px;
        height: 28px;
        background: rgba(57, 125, 255, 1);
        border-radius: 2px;
        text-align: center;
        line-height: 28px;
        color: #fff;
      }
    }
  }
}
</style>
